import axios from 'axios';
import Vue from 'vue';
import * as utils from '../../utils';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'SendSms',
  props: {
    displayDialog: {
      require: true,
      type: Boolean
    },
    closeDialog: {
      type: Function,
      require: true
    },
    bookId: {
      type: String,
      require: true
    },
    walkId: {
      type: Number,
      require: true
    },
    sequence: {
      type: Number,
      require: true
    },
    saveOffline: {
      type: Boolean,
      default: false
    },
    offlineSaveFunc: {
      type: Function,
      default: null
    }

  },
  data: function () {
    return {
      templates: [],
      templateNames: [],
      selectedTemplate: {},
      finalText: '',
      offlineSave: false,
    }
  },
  watch: {
    selectedTemplate: function (val) {
      this.finalText = val ? val.text : '';
    },
  },
 created() {
   this.getSmsTemplates();
   if (this.saveOffline && this.offlineSaveFunc)
     this.offlineSave = true;
  },
  methods: {
    getSmsTemplates() {
      axios.post('/CaptureMeterReading/GetCommonData', {})
        .then(response => {
          //console.log("resp", response)
          this.templates = response.data.smsTemplates;
          this.templates.forEach(t => t['id'] = uuidv4())
        })
        .catch(e => {
          return false;
        })
    },
    sendSmsFunc() {
      if (this.finalText == null || this.finalText.length == 0) {
        return;
      }

      var param = {
        bookId: this.bookId,
        walkId: this.walkId,
        sequence: this.sequence,
        message: this.finalText,
      }

      if (this.offlineSave) {
        let item = {
          parameter: param,
          type: 'adhoc'
        }

        if (this.offlineSaveFunc)
          this.offlineSaveFunc(item);

        this.finalText = '';
        this.callCloseDialog();
        return;
      }

      axios.post('/CaptureMeterReading/SendSms', param)
        .then(response => {
          //console.log("resp", response)
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('sms.smsSendSuccess'), 2);
            this.finalText = '';
            this.callCloseDialog();
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => {
          this.$alertMsg(e);
          return false;
        })
    },
    callCloseDialog() {
      this.finalText = '';
      this.closeDialog();
    }
  },
 
}
